var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6726 4.41083C12.998 4.73626 12.998 5.2639 12.6726 5.58934L8.26183 10.0001L12.6726 14.4108C12.998 14.7363 12.998 15.2639 12.6726 15.5893C12.3471 15.9148 11.8195 15.9148 11.4941 15.5893L6.19943 10.2947C6.03671 10.132 6.03671 9.86817 6.19943 9.70545L11.4941 4.41083C11.8195 4.08539 12.3471 4.08539 12.6726 4.41083Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftBlue);
export default __webpack_public_path__ + "static/media/chevron-left-blue.f617a2bce6096e4df29d0665734b87a0.svg";
export { ForwardRef as ReactComponent };